// extracted by mini-css-extract-plugin
export default {"textBullet":"Bullet_textBullet__chukR","containerBullet":"Bullet_containerBullet__J5dPM","containerContent":"Bullet_containerContent__-6-lm"};